import getCookie from './getCookie.js';
import { getInstance } from '../../msalSingleton.js';

// Erreurs de MSAL qui ne disent rien de l'accès de l'usager : l'iframe ou le réseau n'a pas répondu,
// typiquement à la sortie de veille. ssoSilent est alors réessayé ; toute autre erreur est un refus.
const transientErrorCodes = [
  'monitor_window_timeout',
  'timed_out',
  'no_network_connectivity',
  'get_request_failed',
  'post_request_failed'
];

// Délai avant chaque nouvel essai. On compte des essais et non une durée : une veille gèle les
// timers, et l'essai suivant part au réveil au lieu d'avoir épuisé son délai pendant la veille.
const retryDelays = [5000, 15000, 30000, 60000];

export default async function refreshMicrosoftIdentity() {
  const msalClient = getInstance();
  if (msalClient == null) return;

  const loginHint = getCookie('msal-login-hint');
  if (loginHint == null) return;

  const request = {
    redirectUri: window.location.hostname.endsWith('.localhost')
      ? `http://localhost:8080/entra-id-redirect.html?server-port=${window.location.port}&domain-name=${window.location.hostname.replace(
          '.localhost',
          ''
        )}`
      : `${window.location.origin}/entra-id-redirect.html`,
    loginHint
  };

  for (let attempt = 0; ; attempt++) {
    try {
      const response = await msalClient.ssoSilent(request);
      const { idToken } = response;
      return idToken;
    } catch (err) {
      if (!transientErrorCodes.includes(err.errorCode) || attempt >= retryDelays.length) {
        console.error(err);

        throw Object.assign(new Error(`Error while refreshing msal identity : ${err.message}`), {
          status: 401
        });
      }

      console.warn(`ssoSilent failed (${err.errorCode}), retrying`, err);
      await waitBeforeRetry(retryDelays[attempt]);
    }
  }
}

async function waitBeforeRetry(delay) {
  await new Promise(resolve => setTimeout(resolve, delay));

  if (typeof navigator !== 'undefined' && navigator.onLine === false) {
    await new Promise(resolve => window.addEventListener('online', resolve, { once: true }));
  }
}
